import {
  type DomainAccessControlConfig,
  type DomainAccessControlConfigItem,
} from 'domains/products/utils/domain/accessControl'
import { Flipper } from 'domains/products/access-control/flippers'
import { Permission } from './permissions'

const productsViewWarehouseAccessControl: DomainAccessControlConfig = {
  warehouseFlippers: [Flipper.ProductsViewPage],
}

export const productsViewInternalAccessControl: DomainAccessControlConfig = {
  permissions: Permission.InstacartInternal,
}

export const productsViewVBOAccessControl: DomainAccessControlConfig = {
  permissions: productsViewInternalAccessControl.permissions,
  flippers: [Flipper.ProductsValueBasedOverrides],
}

export const productsViewAccessControl: DomainAccessControlConfig = [
  productsViewWarehouseAccessControl,
  productsViewInternalAccessControl,
] as DomainAccessControlConfigItem[]

export const productsViewInAssortmentAccessControl: DomainAccessControlConfig = {
  permissions: Permission.ProductAttributesEdit,
}
